import { JustifyContent } from '@payflip/types/product-builder';
import styled, { css } from 'styled-components';
import { h6 } from '../heading';

export const resetAnchor = css`
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  color: inherit;
  text-decoration: none;
  cursor: pointer;
`;

export const StyledEmoji = styled.span`
  margin-right: ${({ theme }): string => theme.spacing_unit_x2};
`;

export const StyledText = styled.span<{ allowTextWrap: boolean }>`
  ${h6};
  white-space: ${({ allowTextWrap }): string =>
    allowTextWrap ? 'normal' : 'nowrap'};
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
`;

export const ContentWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const StyledIcon = styled.span`
  height: 1em;
  margin-right: ${({ theme }): string => theme.spacing_unit_x1};
  align-items: center;
  margin-left: auto;
  color: ${({ theme }): string => theme.palette_blue_100};

  & > svg {
    height: 100%;
  }
`;

export const StyledLinkCard = styled.a<{
  $fullWidth: boolean;
  $contentLayout: JustifyContent;
}>`
  ${resetAnchor}
  overflow: hidden;
  display: flex;
  align-items: center;
  transition: all 250ms ease;
  min-width: 280px;
  padding: ${({ theme }): string =>
    `${theme.spacing_unit_x2} ${theme.spacing_unit_x4}`};
  box-sizing: border-box;
  justify-content: ${({ $contentLayout }): string => $contentLayout};
  border-style: solid;
  border-width: 1px;
  border-color: ${({ theme }): string => theme.palette_gray_5};
  border-radius: 8px;

  ${({ $fullWidth }): { [key: string]: string } => {
    if ($fullWidth) {
      return {
        width: 'auto'
      };
    } else {
      return {
        width: 'fit-content'
      };
    }
  }};
`;
